import { Game } from '../game.model';
import { Joker } from '../joker.model';
import { Player } from '../player.model';

export class Jokered {
  game: Game;
  player: Player;
  joker: Joker;
}
